import { render, staticRenderFns } from "./marketingList.vue?vue&type=template&id=4181f22b&scoped=true&"
import script from "./marketingList.vue?vue&type=script&lang=ts&"
export * from "./marketingList.vue?vue&type=script&lang=ts&"
import style0 from "./marketingList.vue?vue&type=style&index=0&id=4181f22b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4181f22b",
  null
  
)

export default component.exports